var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowToSwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1313,
    height: 792,
    viewBox: "0 0 1313 792",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1302:5189)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M628.219 587.576C810.042 587.576 957.438 502.158 957.438 396.788C957.438 291.419 810.042 206 628.219 206C446.396 206 299 291.419 299 396.788C299 502.158 446.396 587.576 628.219 587.576Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M627.095 533.694C757.486 533.694 863.189 472.425 863.189 396.847C863.189 321.268 757.486 260 627.095 260C496.703 260 391 321.268 391 396.847C391 472.425 496.703 533.694 627.095 533.694Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M627.68 478.169C705.928 478.169 769.36 441.419 769.36 396.085C769.36 350.751 705.928 314 627.68 314C549.432 314 486 350.751 486 396.085C486 441.419 549.432 478.169 627.68 478.169Z",
    fill: "#D6D6D6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M347.041 321.538C341.998 321.538 336.955 320.248 332.38 317.668L175.453 228.079L176.04 227.023L332.967 316.613C341.646 321.538 352.553 321.538 361.233 316.496L548.537 207.44L549.123 208.496L361.819 317.551C357.362 320.248 352.202 321.538 347.041 321.538Z",
    fill: "#746F95"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M345.047 443.375L257.552 392.834C248.99 387.909 238.2 387.909 229.638 392.834L190.348 415.466C181.317 420.626 170.175 420.626 161.261 415.466L72.9453 364.456L73.8836 363.987L569.061 78.2153C577.505 73.2902 588.061 73.2902 596.506 78.2153L616.913 90.059L616.327 91.1143L595.919 79.2707C587.827 74.5801 577.74 74.5801 569.647 79.2707L75.4083 364.574L161.965 414.528C170.526 419.453 181.317 419.453 189.878 414.528L229.169 391.896C238.2 386.736 249.342 386.736 258.256 391.896L345.75 442.437L345.047 443.375Z",
    fill: "#746F95"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M413.658 678.723L413.072 677.668L467.961 646.007C470.424 644.599 471.949 642.02 471.949 639.088C471.949 636.156 470.424 633.577 467.961 632.169L324.404 548.912C321.472 547.27 319.713 544.221 319.713 540.821C319.713 537.42 321.472 534.371 324.404 532.73L413.072 481.603L413.658 482.658L324.991 533.785C322.41 535.309 320.886 537.889 320.886 540.821C320.886 543.752 322.41 546.449 324.991 547.857L468.548 631.114C471.48 632.756 473.122 635.805 473.122 639.088C473.122 642.371 471.362 645.42 468.548 647.062L413.658 678.723Z",
    fill: "#A29FB9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M752.377 595.583C747.334 595.583 742.291 594.293 737.717 591.714L493.529 450.763C490.714 449.121 488.955 446.189 488.955 442.906C488.955 439.622 490.714 436.691 493.529 435.049L616.327 364.104L616.913 365.16L494.116 435.987C491.653 437.394 490.128 439.974 490.128 442.789C490.128 445.603 491.653 448.183 494.116 449.707L738.303 590.658C746.982 595.701 757.772 595.701 766.334 590.658L989.41 461.903L989.997 462.958L767.038 591.714C762.464 594.293 757.42 595.583 752.377 595.583Z",
    fill: "#A29FB9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M718.13 697.837L459.752 548.678C456.819 547.036 455.177 543.987 455.177 540.704C455.177 537.42 456.937 534.371 459.752 532.73L479.807 521.121L345.164 443.375L345.75 442.319L482.27 521.121L460.338 533.785C457.875 535.192 456.35 537.772 456.35 540.704C456.35 543.635 457.875 546.215 460.338 547.622L718.717 696.782L718.13 697.837Z",
    fill: "#A29FB9"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M989.998 462.959L989.412 461.903L1112.8 391.428C1115.38 390.02 1116.78 387.441 1116.78 384.509C1116.78 381.577 1115.26 378.998 1112.8 377.59L1038.55 334.789L955.868 286.946L888.077 326.112L887.725 325.877L663.242 196.418C660.31 194.776 658.668 191.727 658.668 188.444C658.668 185.043 660.427 182.112 663.242 180.47L705.113 156.314C707.576 154.906 709.1 152.209 709.1 149.395C709.1 146.463 707.576 143.884 705.113 142.476L616.445 91.1149L617.032 90.0596L705.816 141.304C708.749 142.946 710.391 145.994 710.391 149.278C710.391 152.678 708.631 155.61 705.816 157.252L663.828 181.408C661.365 182.815 659.841 185.512 659.841 188.327C659.841 191.258 661.365 193.838 663.828 195.245L887.96 324.587L955.751 285.421L956.103 285.656L1039.14 333.617L1113.38 376.418C1116.31 378.06 1117.96 381.108 1117.96 384.392C1117.96 387.675 1116.2 390.724 1113.26 392.366L989.998 462.959Z",
    fill: "#453F72"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M617.032 365.161L616.445 364.106L703.823 313.682C712.854 308.405 724.113 308.405 733.144 313.682L804.336 354.49C812.311 359.063 825.799 361.174 834.947 355.897L1024.01 246.725L1024.6 247.78L835.534 356.953C825.916 362.464 812.311 360.471 803.75 355.545L732.558 314.738C723.878 309.695 713.088 309.813 704.409 314.738L617.032 365.161Z",
    fill: "#453F72"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M752.044 90.031L548.602 207.471L549.188 208.486L752.63 91.0465L752.044 90.031Z",
    fill: "#453F72"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M548.676 481.615L480.859 520.836L481.27 521.546L549.087 482.325L548.676 481.615Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1088.63 368.678L992.107 312.978L995.157 307.818L1091.68 363.519L1088.63 368.678Z",
    fill: "url(#paint0_linear_1302:5189)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1232.64 446.895L1231.71 448.521L1237.09 451.626L1238.03 450L1232.64 446.895Z",
    fill: "#1E1851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1226.21 445.486L1220.81 442.32L1221.75 440.678L1227.15 443.844L1226.21 445.486ZM1215.42 439.271L1193.72 426.841L1194.66 425.199L1216.36 437.629L1215.42 439.271Z",
    fill: "#1E1851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1182.93 420.509L1172.14 414.294L1173.08 412.652L1183.87 418.867L1182.93 420.509ZM1166.75 411.128L1161.35 407.961L1162.29 406.32L1167.68 409.486L1166.75 411.128ZM1155.96 404.913L1134.26 392.483L1135.2 390.841L1156.89 403.271L1155.96 404.913ZM1123.47 386.268L1112.68 380.053L1113.62 378.411L1124.41 384.626L1123.47 386.268ZM1107.17 376.887L1101.77 373.72L1102.71 372.079L1108.1 375.245L1107.17 376.887ZM1096.38 370.672L1074.68 358.242L1075.62 356.6L1097.31 369.03L1096.38 370.672ZM1063.89 351.909L1053.1 345.694L1054.04 344.053L1064.83 350.268L1063.89 351.909ZM1047.7 342.528L1042.31 339.362L1043.25 337.72L1048.64 340.887L1047.7 342.528ZM1036.91 336.313L1015.21 323.883L1016.15 322.242L1037.85 334.672L1036.91 336.313ZM1004.42 317.551L993.634 311.336L994.572 309.694L1005.36 315.909L1004.42 317.551ZM988.239 308.287L982.844 305.121L983.782 303.479L989.177 306.645L988.239 308.287ZM977.331 301.955L955.633 289.525L956.572 287.883L978.269 300.313L977.331 301.955ZM944.961 283.31L934.17 277.095L935.109 275.453L945.899 281.668L944.961 283.31ZM928.658 273.929L923.263 270.763L924.201 269.121L929.596 272.287L928.658 273.929ZM917.868 267.714L896.17 255.284L897.108 253.642L918.806 266.072L917.868 267.714ZM885.38 248.952L874.59 242.737L875.528 241.095L886.318 247.31L885.38 248.952ZM869.194 239.571L863.799 236.404L864.738 234.763L870.133 237.929L869.194 239.571ZM858.287 233.356L836.589 220.926L837.527 219.284L859.225 231.714L858.287 233.356ZM825.916 214.593L815.126 208.378L816.064 206.737L826.854 212.952L825.916 214.593ZM809.614 205.33L804.219 202.163L805.157 200.522L810.552 203.688L809.614 205.33ZM798.823 198.997L777.126 186.567L778.064 184.926L799.762 197.356L798.823 198.997ZM766.335 180.352L755.545 174.137L756.483 172.496L767.274 178.711L766.335 180.352ZM750.15 170.971L744.755 167.805L745.693 166.163L751.088 169.33L750.15 170.971ZM739.36 164.756L717.662 152.326L718.6 150.685L740.298 163.115L739.36 164.756Z",
    fill: "#1E1851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M702.389 141.213L701.451 142.838L706.836 145.943L707.774 144.318L702.389 141.213Z",
    fill: "#1E1851"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M744.872 163.35L860.045 229.721L856.996 234.998L741.822 168.626L744.872 163.35Z",
    fill: "url(#paint1_linear_1302:5189)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1106.11 370.672L1153.96 398.229L1153.02 399.753L1105.17 372.079L1106.11 370.672Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M909.891 257.513L1033.51 328.809L1032.57 330.216L909.07 259.037L909.891 257.513Z",
    fill: "#13BCCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M810.669 203.806L934.287 274.985L933.349 276.509L809.848 205.33L810.669 203.806Z",
    fill: "#4FB8C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M989.177 309.577L996.683 313.916L995.159 316.496L987.652 312.157L989.177 309.577Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M882.447 244.613L889.953 248.952L888.428 251.532L880.922 247.193L882.447 244.613Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1147.86 395.767L1178.01 413.122L1174.96 418.281L1144.81 400.926L1147.86 395.767Z",
    fill: "#13BCCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M735.84 161.708L750.853 170.268L747.803 175.545L732.791 166.868L735.84 161.708Z",
    fill: "#13BCCA"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M379.528 466.945L277.373 407.962L280.54 402.45L382.812 461.434L379.528 466.945Z",
    fill: "url(#paint2_linear_1302:5189)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M531.977 549.82L530.98 551.547L536.67 554.828L537.666 553.101L531.977 549.82Z",
    fill: "#1E1851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M525.314 548.209L519.567 544.926L520.505 543.167L526.252 546.45L525.314 548.209ZM513.82 541.643L490.949 528.392L491.887 526.633L514.758 539.884L513.82 541.643Z",
    fill: "#1E1851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M479.455 521.825L467.961 515.258L468.899 513.499L480.393 520.066L479.455 521.825ZM462.214 511.857L456.584 508.574L457.522 506.815L463.269 510.098L462.214 511.857ZM450.837 505.291L427.967 492.04L428.905 490.281L451.775 503.532L450.837 505.291ZM416.473 485.473L404.979 478.906L405.917 477.147L417.411 483.714L416.473 485.473ZM399.232 475.506L393.485 472.222L394.423 470.463L400.17 473.747L399.232 475.506ZM387.738 468.939L364.867 455.688L365.805 453.929L388.676 467.18L387.738 468.939ZM353.373 449.121L341.879 442.554L342.818 440.796L354.312 447.362L353.373 449.121ZM336.132 439.271L330.385 435.988L331.324 434.229L337.071 437.512L336.132 439.271ZM324.756 432.587L301.768 419.336L302.706 417.577L325.577 430.828L324.756 432.587ZM290.391 412.769L278.897 406.203L279.836 404.444L291.329 411.01L290.391 412.769ZM273.15 402.919L267.403 399.636L268.342 397.877L274.089 401.16L273.15 402.919ZM261.656 396.235L238.786 383.102L239.724 381.343L262.595 394.594L261.656 396.235ZM227.292 376.418L215.798 369.851L216.736 368.092L228.23 374.659L227.292 376.418ZM210.168 366.567L204.421 363.167L205.36 361.408L211.107 364.691L210.168 366.567ZM198.674 359.883L175.686 346.75L176.625 344.991L199.495 358.242L198.674 359.883ZM164.31 340.066L152.816 333.499L153.754 331.74L165.248 338.307L164.31 340.066ZM147.069 330.216L141.322 326.932L142.26 325.173L148.007 328.457L147.069 330.216ZM135.575 323.532L112.704 310.398L113.643 308.639L136.513 321.89L135.575 323.532ZM101.211 303.714L89.7166 297.147L90.6548 295.388L102.149 301.955L101.211 303.714ZM84.0869 293.864L78.3399 290.581L79.2782 288.822L85.0252 292.105L84.0869 293.864ZM72.593 287.18L49.6051 274.046L50.5434 272.287L73.414 285.538L72.593 287.18ZM38.2285 267.362L26.7345 260.795L27.6728 259.037L39.1667 265.603L38.2285 267.362ZM20.9875 257.512L15.2406 254.229L16.1789 252.47L21.9258 255.753L20.9875 257.512ZM9.49362 250.828L-13.377 237.695L-12.4387 235.936L10.4319 249.186L9.49362 250.828Z",
    fill: "#1E1851"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M15.4754 249.421L137.334 319.779L134.168 325.291L12.1914 254.932L15.4754 249.421Z",
    fill: "url(#paint3_linear_1302:5189)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M398.059 468.939L448.726 498.138L447.788 499.78L397.121 470.581L398.059 468.939Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M190.229 349.213L321.119 424.614L320.181 426.255L189.291 350.737L190.229 349.213Z",
    fill: "#13BCCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M85.1434 292.223L216.033 367.741L215.095 369.265L84.2051 293.864L85.1434 292.223Z",
    fill: "#4FB8C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M274.089 404.326L282.065 408.899L280.54 411.596L272.564 407.023L274.089 404.326Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M161.144 335.493L169.119 340.066L167.595 342.763L159.619 338.19L161.144 335.493Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M442.276 495.558L474.177 513.968L470.894 519.479L439.109 501.069L442.276 495.558Z",
    fill: "#13BCCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M5.8581 247.662L21.8089 256.809L18.5249 262.32L2.69141 253.174L5.8581 247.662Z",
    fill: "#13BCCA"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M956.805 839.141L834.594 768.783L838.464 762.099L960.558 832.574L956.805 839.141Z",
    fill: "url(#paint4_linear_1302:5189)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1076.2 904.808L1062.48 896.952L1063.65 894.841L1077.37 902.698L1076.2 904.808ZM1055.56 892.965L1048.76 888.978L1049.93 886.867L1056.73 890.854L1055.56 892.965ZM1041.95 885.108L1014.51 869.277L1015.68 867.167L1043.13 882.997L1041.95 885.108ZM1000.79 861.421L987.064 853.564L988.237 851.453L1001.96 859.31L1000.79 861.421ZM980.262 849.577L973.459 845.59L974.632 843.479L981.434 847.466L980.262 849.577ZM966.539 841.603L939.095 825.773L940.267 823.662L967.712 839.492L966.539 841.603ZM925.489 817.916L911.767 810.059L912.94 807.948L926.662 815.805L925.489 817.916ZM904.965 806.072L898.162 802.085L899.335 799.975L906.137 803.962L904.965 806.072ZM891.242 798.216L863.798 782.385L864.97 780.274L892.415 796.105L891.242 798.216ZM850.075 774.528L836.353 766.672L837.526 764.561L851.248 772.418L850.075 774.528ZM829.55 762.685L822.748 758.698L823.921 756.587L830.723 760.574L829.55 762.685ZM815.828 754.711L788.501 738.997L789.673 736.887L817.118 752.717L815.828 754.711ZM774.778 731.023L761.056 723.167L762.229 721.056L775.951 728.913L774.778 731.023ZM754.253 719.18L747.451 715.193L748.624 713.082L755.426 717.069L754.253 719.18ZM740.531 711.323L713.086 695.492L714.259 693.382L741.704 709.212L740.531 711.323ZM699.481 687.636L685.759 679.779L686.932 677.668L700.654 685.525L699.481 687.636ZM678.839 675.792L672.037 671.805L673.209 669.694L680.012 673.681L678.839 675.792ZM665.234 667.818L637.789 651.988L638.962 649.877L666.407 665.707L665.234 667.818ZM624.067 644.131L610.345 636.274L611.517 634.163L625.24 642.02L624.067 644.131ZM603.542 632.287L596.74 628.3L597.912 626.19L604.715 630.176L603.542 632.287ZM589.82 624.431L562.375 608.6L563.548 606.489L590.993 622.32L589.82 624.431ZM548.77 600.743L535.048 592.887L536.221 590.776L549.943 598.632L548.77 600.743ZM528.245 588.9L521.443 584.913L522.615 582.802L529.418 586.789L528.245 588.9ZM514.523 581.043L487.078 565.212L488.251 563.102L515.696 578.932L514.523 581.043Z",
    fill: "#1E1851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M467.736 551.298L466.564 553.33L473.372 557.255L474.544 555.224L467.736 551.298Z",
    fill: "#1E1851"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M521.56 579.284L667.228 663.245L663.475 669.929L517.689 585.851L521.56 579.284Z",
    fill: "url(#paint5_linear_1302:5189)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M730.446 698.424L886.905 788.6L885.732 790.593L729.391 700.417L730.446 698.424Z",
    fill: "#13BCCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M604.833 630.411L761.291 720.587L760.118 722.581L603.777 632.405L604.833 630.411Z",
    fill: "#4FB8C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M830.724 764.326L840.224 769.838L838.348 773.121L828.848 767.61L830.724 764.326Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M695.728 682.125L705.228 687.636L703.352 690.92L693.852 685.408L695.728 682.125Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M510.068 577.057L529.185 588.079L525.315 594.646L506.314 583.623L510.068 577.057Z",
    fill: "#13BCCA"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M295.788 359.766L417.882 289.29L414.129 282.724L291.918 353.199L295.788 359.766Z",
    fill: "url(#paint6_linear_1302:5189)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M113.497 458.931L106.689 462.856L107.861 464.888L114.669 460.963L113.497 458.931Z",
    fill: "#1E1851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M121.503 456.978L120.33 454.867L127.133 450.88L128.305 452.991L121.503 456.978ZM135.225 449.121L134.052 447.01L161.497 431.18L162.67 433.29L135.225 449.121Z",
    fill: "#1E1851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M176.392 425.433L175.219 423.323L188.941 415.466L190.114 417.577L176.392 425.433ZM196.916 413.59L195.744 411.479L202.546 407.492L203.719 409.603L196.916 413.59ZM210.639 405.733L209.466 403.622L236.911 387.792L238.084 389.902L210.639 405.733ZM251.689 381.929L250.516 379.818L264.238 371.961L265.411 374.072L251.689 381.929ZM272.213 370.085L271.041 367.974L277.843 363.987L279.016 366.098L272.213 370.085ZM285.936 362.228L284.763 360.117L312.208 344.287L313.38 346.398L285.936 362.228ZM326.986 338.541L325.813 336.43L339.535 328.574L340.708 330.684L326.986 338.541ZM347.628 326.697L346.455 324.587L353.257 320.6L354.43 322.71L347.628 326.697ZM361.233 318.841L360.06 316.73L387.505 300.899L388.677 303.01L361.233 318.841ZM402.4 295.153L401.227 293.043L414.949 285.186L416.122 287.297L402.4 295.153ZM422.925 283.192L421.752 281.082L428.554 277.095L429.727 279.205L422.925 283.192ZM436.647 275.336L435.474 273.225L462.919 257.394L464.092 259.505L436.647 275.336ZM477.697 251.648L476.524 249.538L490.246 241.681L491.419 243.792L477.697 251.648ZM498.222 239.805L497.049 237.694L503.851 233.707L505.024 235.818L498.222 239.805ZM511.944 231.948L510.771 229.837L538.216 214.007L539.389 216.118L511.944 231.948ZM553.111 208.261L551.938 206.15L565.661 198.293L566.833 200.404L553.111 208.261ZM573.636 196.417L572.463 194.306L579.266 190.319L580.438 192.43L573.636 196.417ZM587.358 188.443L586.185 186.332L613.63 170.502L614.803 172.613L587.358 188.443ZM628.408 164.756L627.235 162.645L640.957 154.789L642.13 156.899L628.408 164.756ZM648.933 152.912L647.76 150.802L654.563 146.815L655.735 148.925L648.933 152.912ZM662.655 145.056L661.482 142.945L688.927 127.114L690.1 129.225L662.655 145.056ZM703.705 121.368L702.532 119.258L716.254 111.401L717.427 113.512L703.705 121.368ZM724.347 109.525L723.174 107.414L729.977 103.427L731.15 105.538L724.347 109.525ZM737.952 101.551L736.779 99.44L764.224 83.6094L765.397 85.7201L737.952 101.551Z",
    fill: "#1E1851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M784.692 71.8365L777.885 75.7617L779.057 77.7934L785.864 73.8682L784.692 71.8365Z",
    fill: "#1E1851"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M730.914 99.9092L585.246 183.87L589.116 190.437L734.784 106.476L730.914 99.9092Z",
    fill: "url(#paint7_linear_1302:5189)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M273.738 362.229L213.102 397.173L214.157 399.049L274.793 364.105L273.738 362.229Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M522.031 219.05L365.572 309.226L366.745 311.102L523.203 220.926L522.031 219.05Z",
    fill: "#13BCCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M647.642 151.036L491.184 241.212L492.356 243.088L648.697 152.912L647.642 151.036Z",
    fill: "#4FB8C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M421.752 284.952L412.252 290.464L414.128 293.747L423.629 288.236L421.752 284.952Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M556.746 202.75L547.246 208.144L549.123 211.427L558.623 206.033L556.746 202.75Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M220.725 394.007L182.607 416.052L186.478 422.619L224.596 400.691L220.725 394.007Z",
    fill: "#13BCCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M742.408 97.6816L723.408 108.704L727.161 115.271L746.279 104.248L742.408 97.6816Z",
    fill: "#13BCCA"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M825.681 561.812L947.892 491.454L944.021 484.77L821.811 555.245L825.681 561.812Z",
    fill: "url(#paint8_linear_1302:5189)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M643.507 660.946L636.699 664.871L637.871 666.903L644.679 662.978L643.507 660.946Z",
    fill: "#1E1851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M651.513 659.14L650.34 657.029L657.142 653.042L658.315 655.153L651.513 659.14ZM665.235 651.166L664.062 649.055L691.507 633.225L692.68 635.335L665.235 651.166Z",
    fill: "#1E1851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M706.286 627.479L705.113 625.368L718.836 617.512L720.008 619.623L706.286 627.479ZM726.811 615.636L725.638 613.525L732.441 609.538L733.614 611.649L726.811 615.636ZM740.533 607.779L739.36 605.668L766.805 589.838L767.978 591.948L740.533 607.779ZM781.7 584.092L780.528 581.981L794.25 574.124L795.423 576.235L781.7 584.092ZM802.225 572.248L801.052 570.137L807.855 566.15L809.028 568.261L802.225 572.248ZM815.948 564.274L814.775 562.163L842.219 546.333L843.392 548.443L815.948 564.274ZM856.997 540.587L855.825 538.476L869.547 530.619L870.72 532.73L856.997 540.587ZM877.522 528.743L876.349 526.632L883.152 522.645L884.325 524.756L877.522 528.743ZM891.245 520.886L890.072 518.776L917.516 502.945L918.689 505.056L891.245 520.886ZM932.294 497.199L931.121 495.088L944.844 487.232L946.017 489.342L932.294 497.199ZM952.936 485.356L951.764 483.245L958.566 479.258L959.739 481.369L952.936 485.356ZM966.542 477.382L965.369 475.271L992.813 459.44L993.986 461.551L966.542 477.382ZM1007.71 453.694L1006.54 451.584L1020.26 443.727L1021.43 445.838L1007.71 453.694ZM1028.23 441.851L1027.06 439.74L1033.86 435.753L1035.04 437.864L1028.23 441.851ZM1041.96 433.994L1040.78 431.883L1068.23 416.053L1069.4 418.163L1041.96 433.994ZM1083.01 410.307L1081.83 408.196L1095.56 400.339L1096.73 402.45L1083.01 410.307ZM1103.65 398.463L1102.47 396.352L1109.28 392.365L1110.45 394.476L1103.65 398.463ZM1117.25 390.489L1116.08 388.378L1143.52 372.548L1144.7 374.658L1117.25 390.489ZM1158.42 366.802L1157.25 364.691L1170.97 356.834L1172.14 358.945L1158.42 366.802ZM1178.94 354.958L1177.77 352.847L1184.57 348.86L1185.75 350.971L1178.94 354.958ZM1192.67 347.101L1191.49 344.991L1218.94 329.16L1220.11 331.271L1192.67 347.101ZM1233.72 323.414L1232.54 321.303L1246.27 313.447L1247.44 315.557L1233.72 323.414ZM1254.24 311.571L1253.07 309.46L1259.87 305.473L1261.04 307.584L1254.24 311.571ZM1267.96 303.714L1266.79 301.603L1294.24 285.772L1295.41 287.883L1267.96 303.714Z",
    fill: "#1E1851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1314.76 273.953L1307.95 277.878L1309.13 279.91L1315.93 275.984L1314.76 273.953Z",
    fill: "#1E1851"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1260.93 301.955L1115.14 385.916L1119.01 392.6L1264.8 308.522L1260.93 301.955Z",
    fill: "url(#paint9_linear_1302:5189)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M803.632 564.274L743.113 599.219L744.169 601.213L804.805 566.268L803.632 564.274Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1052.04 421.095L895.584 511.271L896.64 513.264L1053.1 423.088L1052.04 421.095Z",
    fill: "#13BCCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1177.65 353.082L1021.2 443.258L1022.25 445.251L1178.71 355.076L1177.65 353.082Z",
    fill: "#4FB8C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M951.762 486.997L942.145 492.508L944.138 495.792L953.639 490.28L951.762 486.997Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1086.76 404.795L1077.26 410.306L1079.13 413.59L1088.63 408.078L1086.76 404.795Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M750.737 596.17L712.619 618.098L716.49 624.665L754.607 602.737L750.737 596.17Z",
    fill: "#13BCCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1272.3 299.727L1253.3 310.749L1257.17 317.316L1276.17 306.293L1272.3 299.727Z",
    fill: "#13BCCA"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M69.7786 370.554L191.99 300.078L188.119 293.512L65.9082 363.87L69.7786 370.554Z",
    fill: "url(#paint10_linear_1302:5189)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M-49.6162 436.104L-50.7891 433.994L-37.0667 426.137L-35.8939 428.248L-49.6162 436.104ZM-29.0913 424.261L-30.2642 422.15L-23.4617 418.163L-22.2888 420.274L-29.0913 424.261ZM-15.369 416.404L-16.5418 414.293L10.9028 398.463L12.0757 400.573L-15.369 416.404ZM25.798 392.717L24.6252 390.606L38.3475 382.749L39.5204 384.86L25.798 392.717ZM46.3229 380.873L45.1501 378.762L51.9526 374.775L53.1255 376.886L46.3229 380.873ZM60.0453 372.899L58.8724 370.788L86.3171 354.958L87.49 357.068L60.0453 372.899ZM101.095 349.212L99.9222 347.101L113.645 339.244L114.817 341.355L101.095 349.212ZM121.62 337.368L120.447 335.257L127.25 331.27L128.422 333.381L121.62 337.368ZM135.342 329.511L134.169 327.401L161.614 311.57L162.787 313.681L135.342 329.511ZM176.392 305.824L175.219 303.713L188.941 295.857L190.114 297.967L176.392 305.824ZM197.034 293.981L195.861 291.87L202.664 287.883L203.837 289.994L197.034 293.981ZM210.639 286.007L209.466 283.896L236.911 268.065L238.084 270.176L210.639 286.007ZM251.806 262.319L250.633 260.209L264.356 252.352L265.529 254.463L251.806 262.319ZM272.331 250.476L271.158 248.365L277.961 244.378L279.134 246.489L272.331 250.476ZM286.053 242.619L284.881 240.508L312.325 224.678L313.498 226.788L286.053 242.619ZM327.103 218.932L325.93 216.821L339.653 208.964L340.826 211.075L327.103 218.932ZM347.628 207.088L346.455 204.977L353.258 200.99L354.431 203.101L347.628 207.088ZM361.35 199.231L360.178 197.121L387.622 181.29L388.795 183.401L361.35 199.231ZM402.517 175.427L401.345 173.316L415.067 165.459L416.24 167.57L402.517 175.427ZM423.042 163.583L421.87 161.472L428.672 157.485L429.845 159.596L423.042 163.583ZM436.765 155.726L435.592 153.616L463.037 137.785L464.209 139.896L436.765 155.726ZM477.814 132.039L476.642 129.928L490.364 122.072L491.537 124.182L477.814 132.039ZM498.339 120.196L497.166 118.085L503.969 114.098L505.142 116.209L498.339 120.196ZM512.062 112.339L510.889 110.228L538.333 94.3975L539.506 96.5082L512.062 112.339Z",
    fill: "#1E1851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M558.829 82.6071L552.021 86.5322L553.193 88.5639L560.001 84.6388L558.829 82.6071Z",
    fill: "#1E1851"
  }))), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M505.023 110.58L359.238 194.658L363.109 201.225L508.894 117.147L505.023 110.58Z",
    fill: "url(#paint11_linear_1302:5189)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M47.73 372.899L-12.7891 407.844L-11.7335 409.838L48.9028 374.893L47.73 372.899Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M296.14 229.721L139.682 320.014L140.737 321.89L297.195 231.714L296.14 229.721Z",
    fill: "#13BCCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M421.751 161.707L265.293 251.883L266.349 253.876L422.807 163.701L421.751 161.707Z",
    fill: "#4FB8C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M195.86 295.623L186.242 301.135L188.236 304.418L197.736 298.906L195.86 295.623Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M330.856 213.421L321.238 218.932L323.232 222.216L332.732 216.704L330.856 213.421Z",
    fill: "#DFD71E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M516.4 108.353L497.4 119.375L501.271 125.942L520.271 115.037L516.4 108.353Z",
    fill: "#13BCCA"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M637.68 478.203C715.928 478.203 779.36 441.452 779.36 396.118C779.36 350.784 715.928 314.033 637.68 314.033C559.432 314.033 496 350.784 496 396.118C496 441.452 559.432 478.203 637.68 478.203Z",
    fill: "#746F95"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M637.681 435.049C674.732 435.049 704.768 417.618 704.768 396.117C704.768 374.616 674.732 357.186 637.681 357.186C600.63 357.186 570.594 374.616 570.594 396.117C570.594 417.618 600.63 435.049 637.681 435.049Z",
    fill: "#453F72"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1302:5189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.215 132.486C576.974 130.34 577.865 128.252 578.872 126.237C587.471 109.241 605.093 97.5889 625.445 97.5889C648.307 97.5889 667.739 112.307 674.776 132.778",
    stroke: "#1F1550",
    strokeWidth: 1.1889,
    strokeMiterlimit: 10,
    strokeDasharray: "4.67 4.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.221 111.844C654.33 101.239 653.928 84.4452 643.324 74.335C632.72 64.2248 615.928 64.6262 605.82 75.2317C595.711 85.8372 596.112 102.631 606.716 112.741C617.32 122.851 634.112 122.449 644.221 111.844Z",
    fill: "#EDEA66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.715 94.1874L621.285 101.415L635.621 85.3682",
    stroke: "#1A0B52",
    strokeWidth: 3.5668,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.754 87.0039C646.484 89.3109 646.834 91.7931 646.732 94.3483C646.279 106.336 636.191 115.696 624.205 115.243C612.218 114.79 602.86 104.701 603.313 92.713C603.765 80.7253 613.854 71.3658 625.84 71.8185C631.49 72.0375 636.556 74.3883 640.293 78.0679",
    stroke: "#1A0B52",
    strokeWidth: 1.1252,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.529 181.401L602.64 221.044L588.434 226.476L574.682 187.023L589.529 181.401Z",
    fill: "#66D9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.356 201.302L614.334 201.142C614.072 201.098 613.897 200.864 613.94 200.601L616.349 185.577C616.393 185.314 616.627 185.139 616.889 185.182L617.911 185.343C618.174 185.387 618.349 185.621 618.306 185.883L615.897 200.908C615.853 201.171 615.619 201.346 615.356 201.302Z",
    fill: "#F3F3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.4 192.586L616.276 186.979",
    stroke: "#1A0B52",
    strokeWidth: 0.8282,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.564 374.489V402.188L567.806 401.925V373.584L554.564 374.489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.756 374.037L591.457 402.188L604.699 401.926L599.998 373.117L586.756 374.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.718 178.831L559.309 165.924L567.995 166.303L569.514 176.889L561.718 178.831Z",
    fill: "#F3F3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.9 172.888L549.322 174.787C540.708 175.385 537.452 181.766 538.737 190.293L549.993 243.048L588.828 240.653L589.865 186.862C590.522 177.882 585.879 172.275 576.9 172.888Z",
    fill: "#66D9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.342 243.355L589.837 238.127C588.625 237.894 587.837 236.74 588.07 235.528L595.618 195.798C595.852 194.586 597.005 193.798 598.217 194.031L625.708 199.259C626.92 199.492 627.708 200.646 627.474 201.858L619.927 241.588C619.708 242.785 618.54 243.588 617.342 243.355Z",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.654 223.088C582.771 223.088 587.954 222.475 587.954 222.475L591.253 217.364L598.057 218.664L597.152 220.095L604.086 221.321L602.758 227.147L591.224 228.856L588.859 228.52L584.1 229.921L582.654 223.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.373 187.125L531.044 231.06C530.372 239.471 538.242 245.983 546.374 243.749L587.968 232.039L585.398 221.526L549.731 227.264L555.425 190.688C556.929 183.796 556.754 177.079 549.191 175.853C543.381 174.933 539.132 179.211 538.373 187.125Z",
    fill: "#66D9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.994 243.048L550.257 378.621L575.543 378.972L579.339 241.237L549.994 243.048Z",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.74 410L558.93 409.913L558.842 405.824L576.566 409.65C576.522 405.138 567.806 401.926 567.806 401.926L554.564 402.189L554.667 406.613L554.74 410Z",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.413 410L595.604 409.913L595.516 405.824L613.24 409.65C613.196 405.138 604.48 401.926 604.48 401.926L591.238 402.189L591.34 406.613L591.413 410Z",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.484 242.464L582.931 378.037L607.78 375.321L588.829 240.639L559.484 242.464Z",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.338 166.041L557.032 154.17C556.126 149.541 559.192 145.015 563.82 144.11C568.448 143.204 572.974 146.271 573.879 150.899L576.142 162.551C576.726 165.588 574.142 168.275 571.091 167.822L559.338 166.041Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.17 167.808L562.418 166.932",
    stroke: "#1A0B52",
    strokeWidth: 1.2028,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.937 150.565C558.278 149.645 559.431 147.001 558.512 144.659C557.592 142.317 554.949 141.164 552.607 142.084C550.265 143.004 549.113 145.648 550.032 147.989C550.952 150.331 553.595 151.484 555.937 150.565Z",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.141 159.747C563.354 157.688 563.47 149.731 563.47 149.731C563.47 149.731 567.12 153.936 572.464 152.169C573.982 151.658 573.967 150.169 573.559 148.796C573.033 147.015 571.777 145.555 570.186 144.576C567.149 142.722 560.083 142.342 556.638 146.752C551.791 152.943 558.141 159.747 558.141 159.747Z",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.032 193.243L549.732 227.293L585.399 221.555",
    stroke: "#1A0B52",
    strokeWidth: 1.2028,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.162 182.657L640.424 183.767C638.965 184.044 637.548 183.095 637.271 181.635L634.409 166.741C634.132 165.281 635.081 163.865 636.541 163.588L642.279 162.478C643.739 162.2 645.155 163.15 645.432 164.61L648.294 179.503C648.571 180.963 647.622 182.365 646.162 182.657Z",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.595 188.381L662.675 194.236L654.616 185.168L652.207 184.526L650.805 180.7L651.769 176.802L646.002 172.801L647.52 172.275L655.346 175.59L658.82 181.722L667.595 188.381Z",
    fill: "#F3F3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.873 185.096L658.748 195.141L684.341 217.657L693.612 206.136L667.873 185.096Z",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.035 161.223H689.465V175.795H700.035V161.223Z",
    fill: "#F3F3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.487 380.33H677.201V403.269H690.487V380.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.964 407.152L719.145 409.985C717.612 410.218 716.882 408.174 718.211 407.386L724.036 403.925L737.176 401.896L737.964 407.152Z",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.756 379.253L720.619 381.234L724.039 403.916L737.176 401.935L733.756 379.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.202 173.779L687.858 171.72C677.93 170.669 669.287 178.437 669.287 188.424V243.982H722.225V190.483C722.225 181.898 715.743 174.685 707.202 173.779Z",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.793 243.982H669.287V390.39H696.793V243.982Z",
    fill: "#66D9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.001 386.156L714.051 390.39L694.721 243.982H722.226L741.001 386.156Z",
    fill: "#66D9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.486 408.525H671.448C669.901 408.525 669.477 406.393 670.923 405.809L677.186 403.254L690.471 403.21V408.525H690.486Z",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.935 197.842L643.183 187.913L644.015 185.664L644.351 179.663L643.183 179.152L641.913 182.525L640.38 182.861L638.131 180.014L637.693 175.195L635.883 174.261L634.803 182.832L639.197 191.563L646.132 202.193L650.935 197.842Z",
    fill: "#F3F3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.644 203.172L670.236 182.817C670.236 182.817 674.558 170.173 684.047 175.166C693.537 180.16 686.544 191.053 686.544 191.053L670.528 218.021C667.302 223.657 659.52 224.519 655.126 219.73L641.344 204.194L652.323 193.841L660.644 203.172Z",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.034 161.222L701.333 149.191C701.844 144.504 698.413 140.24 693.727 139.744C689.04 139.233 684.777 142.664 684.281 147.351L682.996 159.164C682.66 162.23 685.463 164.712 688.471 163.997L700.034 161.222Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.807 140.138L701.889 149.059C701.889 149.059 703.846 142.08 696.356 139.525C687.99 136.677 684.092 144.27 684.092 144.27",
    fill: "#1A0B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.807 140.138L701.889 149.059C701.889 149.059 703.846 142.08 696.356 139.525C687.99 136.677 684.092 144.27 684.092 144.27",
    stroke: "#1A0B52",
    strokeWidth: 0.8282,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.545 191.053L670.529 218.021C670.529 218.021 669.887 219.131 669.273 219.744",
    stroke: "white",
    strokeWidth: 1.2028,
    strokeMiterlimit: 10
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M695.502 409.486L718.724 425.551L778.305 391.545L753.792 375.597L695.502 409.486Z",
    fill: "#453F72"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M516.174 362.111L532.359 373.134L573.526 349.564L556.637 338.541L516.174 362.111Z",
    fill: "#453F72"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M631.113 456.977L613.286 469.524L553.705 435.518L572.705 423.088L631.113 456.977Z",
    fill: "#453F72"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M569.773 322.241L566.958 320.482L558.396 334.906L561.211 336.665L569.773 322.241Z",
    fill: "#1A0B52"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M558.396 334.906V338.307L561.211 336.665L558.396 334.906Z",
    fill: "#99E3E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1302:5189",
    x1: 993.979,
    y1: 310.384,
    x2: 1090.39,
    y2: 366.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#68648A",
    stopOpacity: 0.732
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#A9A7BC",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7427,
    stopColor: "#D7D6E0",
    stopOpacity: 0.2573
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#F4F4F7",
    stopOpacity: 0.0932001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1302:5189",
    x1: 858.856,
    y1: 232.098,
    x2: 743.901,
    y2: 165.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFD71E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1302:5189",
    x1: 279.297,
    y1: 405.167,
    x2: 381.412,
    y2: 464.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#68648A",
    stopOpacity: 0.732
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#A9A7BC",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7427,
    stopColor: "#D7D6E0",
    stopOpacity: 0.2573
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#F4F4F7",
    stopOpacity: 0.0932001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1302:5189",
    x1: 136.159,
    y1: 322.271,
    x2: 14.3977,
    y2: 251.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFD71E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1302:5189",
    x1: 836.838,
    y1: 765.35,
    x2: 958.89,
    y2: 836.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#68648A",
    stopOpacity: 0.732
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#A9A7BC",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7427,
    stopColor: "#D7D6E0",
    stopOpacity: 0.2573
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#F4F4F7",
    stopOpacity: 0.0932001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1302:5189",
    x1: 665.722,
    y1: 666.36,
    x2: 520.187,
    y2: 581.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFD71E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1302:5189",
    x1: 415.529,
    y1: 286.058,
    x2: 293.477,
    y2: 356.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#68648A",
    stopOpacity: 0.732
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#A9A7BC",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7427,
    stopColor: "#D7D6E0",
    stopOpacity: 0.2573
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#F4F4F7",
    stopOpacity: 0.0932001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1302:5189",
    x1: 586.651,
    y1: 187.062,
    x2: 732.187,
    y2: 102.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFD71E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1302:5189",
    x1: 945.75,
    y1: 487.951,
    x2: 823.698,
    y2: 558.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#68648A",
    stopOpacity: 0.732
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#A9A7BC",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7427,
    stopColor: "#D7D6E0",
    stopOpacity: 0.2573
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#F4F4F7",
    stopOpacity: 0.0932001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1302:5189",
    x1: 1116.85,
    y1: 388.967,
    x2: 1262.39,
    y2: 304.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFD71E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1302:5189",
    x1: 189.878,
    y1: 296.569,
    x2: 67.8257,
    y2: 367.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#68648A",
    stopOpacity: 0.732
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#A9A7BC",
    stopOpacity: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7427,
    stopColor: "#D7D6E0",
    stopOpacity: 0.2573
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#F4F4F7",
    stopOpacity: 0.0932001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1302:5189",
    x1: 360.975,
    y1: 197.588,
    x2: 506.51,
    y2: 113.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFD71E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1302:5189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1372,
    height: 792,
    fill: "white",
    transform: "translate(-59)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1302:5189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 343,
    fill: "white",
    transform: "translate(531 67)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToSwitch);
export default __webpack_public_path__ + "static/media/how-to-switch.02dd41dd582cc2c6f5be6fad59ac080d.svg";
export { ForwardRef as ReactComponent };